import React, { useState } from "react";
import Button from "../components/Button";
import Title from "../components/Title";
import styled from "styled-components";
import axios from "axios";

function CreateBook({ history }) {
  const baseUrl = "http://54.180.26.235:8000";

  const [book, setBook] = useState({
    title: "",
    text: "",
  });

  const titleChangeHandler = (event) => {
    event.preventDefault();
    setBook({ ...book, title: event.target.value });
  };

  const contentChangeHandler = (event) => {
    event.preventDefault();
    setBook({
      ...book,
      //줄바꿈 입력 삭제
      text: event.target.value.replace(/(\r\n|\n|\r)/gm, ""),
    });
  };

  //Create 버튼 동작: 서버에 post하고 메인으로 돌아감
  const BookSubmit = () => {
    axios.post(baseUrl + "/books", book);
    history.push("/");
  };

  //back 버튼 동작: 메인으로 돌아감
  const back = () => {
    history.push("/");
  };

  return (
    <CreateBookWrap>
      <div className="container">
        <Title />
        <Button onClick={back} className="btn-back" color="brwn" size="small">
          돌아가기
        </Button>
        <div className="title-form">
          <input
            className="title-form--input"
            type="text"
            value={book.title}
            onChange={titleChangeHandler}
            placeholder="제목을 입력하세요"
            maxLength="20"
          ></input>
        </div>
        <div className="content-form">
          <textarea
            className="content-form--input"
            type="text"
            value={book.text}
            onChange={contentChangeHandler}
            placeholder="내용을 입력하세요"
          ></textarea>
        </div>
        <Button
          onClick={BookSubmit}
          className="btn-done"
          color="brwn"
          size="large"
        >
          작성완료
        </Button>
      </div>
    </CreateBookWrap>
  );
}

export default CreateBook;

const CreateBookWrap = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    margin-top: 104px;
    margin-left: 56px;
  }
  .container {
    width: 710px;
    height: 777px;
    background: #fdf0bc;
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.15);
    border-radius: 30px;
  }
  .btn-back {
    margin-top: 20px;
    margin-left: 50px;
  }
  .btn-done {
    margin-top: 30px;
    margin-left: 529px;
  }
  .title-form {
    width: 600px;
    height: 50px;
    background: #feffcd;
    border-radius: 15px;
    margin-top: 25px;
    margin-left: 50px;
    &--input {
      font-style: normal;
      font-weight: normal;
      font-size: 30px;
      letter-spacing: 0.05em;
      padding-left: 15px;
      border: none;
      outline: none;
      width: 600px;
      height: 50px;
      background: #feffcd;
      color: #2d2d2d;
      border-radius: 15px;
    }
  }
  .content-form {
    width: 600px;
    height: 300px;
    background: #feffcd;
    border-radius: 15px;
    margin-top: 15px;
    margin-left: 50px;
    &--input {
      font-style: normal;
      font-weight: normal;
      font-size: 30px;
      letter-spacing: 0.05em;
      padding-left: 15px;
      padding-top: 10px;
      border: none;
      outline: none;
      width: 600px;
      height: 300px;
      background: #feffcd;
      color: #2d2d2d;
      border-radius: 15px;
      resize: none;
    }
  }
`;
